
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', e => {
    initGallery();
    initTabs();
});

function initGallery() {

    const productCarouselMobile = document.querySelectorAll('.single-product__gallery--mobile');
    if (productCarouselMobile) {
        productCarouselMobile.forEach(carousel => {

            const pagination = carousel.querySelector('.swiper-pagination');

            const swiper = new Swiper(carousel, {
                loop: true,
                loopPreventsSliding: true,
                pagination: {
                    el: pagination, // Selector for the pagination container
                    clickable: true,       // Makes pagination bullets clickable
                    // ... other pagination options like type, renderBullet, dynamicBullets, etc.
                },
                autoplay: {
                    delay: 7500,
                    disableOnInteraction: false,
                },
                slidesPerView: 1,
                spaceBetween: 16,
                autoHeight: true,
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 16,
                    }
                }
            });
        })
    }
}

function initTabs() {
    const tabsWrappers = document.querySelectorAll('.woocommerce-tabs');

    tabsWrappers.forEach(wrapper => {
        wrapper.addEventListener('click', function (e) {
            const tabLink = e.target.closest('.wc-tabs li a, ul.tabs li a');
            if (!tabLink) return;

            const currentHeight = wrapper.offsetHeight;
            wrapper.style.height = `${currentHeight}px`;

            setTimeout(() => {
                const href = tabLink.getAttribute('href');
                if (!href) return;

                const targetId = href.split('#')[1];
                const targetPanel = wrapper.querySelector(`#${targetId}`);
                const nav = wrapper.querySelector('.wc-tabs, ul.tabs');

                if (targetPanel && nav) {
                    const style = window.getComputedStyle(wrapper);
                    const padTop = parseFloat(style.paddingTop) || 0;
                    const padBottom = parseFloat(style.paddingBottom) || 0;
                    const borderTop = parseFloat(style.borderTopWidth) || 0;
                    const borderBottom = parseFloat(style.borderBottomWidth) || 0;

                    const newHeight = nav.offsetHeight + targetPanel.offsetHeight + padTop + padBottom + borderTop + borderBottom;

                    wrapper.style.height = `${newHeight}px`;

                    setTimeout(() => {
                        wrapper.style.height = 'auto';
                    }, 500);
                }
            }, 50);
        });
    });
}
